module.exports = __webpack_public_path__ + "img/Android.17e3a73b.png";